import React from "react";
import { Link } from "react-router-dom";
import Team from "../components/heider/Team";
import ContactForm from "../components/heider/ContactForm";
import Footer from "../components/heider/Footer";
import useReveal from "../hooks/useReveal";
import { founder } from "../mock";
import { ArrowRight } from "lucide-react";

const LeadershipPage = () => {
  useReveal();
  return (
    <div className="page-in">
      <section className="bg-[#0d0d0d] text-white pt-40 pb-20 md:pt-48 md:pb-24">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10">
          <p className="text-[11px] tracking-luxe uppercase text-[#b4936a] mb-5">Company</p>
          <h1 className="font-serif-display text-5xl md:text-7xl font-light" data-testid="leadership-title">Meet Our Leadership</h1>
          <p className="text-white/55 text-[15px] leading-relaxed max-w-2xl mt-6">The vision, standards and work ethic behind every Capital Corner Group sale.</p>
        </div>
      </section>
      <Team />
      <section className="bg-white py-20 md:py-24">
        <div className="max-w-[1300px] mx-auto px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          {founder.stats.map((s) => (
            <div key={s.l} className="reveal border-t border-black/10 pt-6">
              <div className="font-serif-display text-3xl md:text-5xl text-[#1a1a1a] mb-2">{s.v}</div>
              <div className="text-neutral-500 text-[10px] tracking-luxe uppercase">{s.l}</div>
            </div>
          ))}
        </div>
        <div className="text-center mt-14">
          <Link to="/team/omer-reshid" data-testid="leadership-view-profile" className="inline-flex items-center gap-2 text-[11px] tracking-luxe uppercase text-white bg-[#0d0d0d] px-8 py-4 hover:bg-[#b4936a] transition-colors">
            View Omer&rsquo;s Full Profile <ArrowRight size={14} />
          </Link>
        </div>
      </section>
      <ContactForm source="Leadership Page" />
      <Footer />
    </div>
  );
};

export default LeadershipPage;
